import React, { useState, useEffect } from 'react'
import { AddContainer, EditContainer, EditLine, ProfileContainer, ProfileAvatar, ProfileIcon, Texts, TagsContainer, InnerComponent, Component2, HightContainer, HightInner, NextFollowUpText, Component4, HeaderPart, FooterPart, SaveButton, CancelButton } from './Style'
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg'
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme';
import InputComponent from 'src/components/shared/Form/Input';
import { palette, shadows } from 'src/config/theme.js';
import { alpha } from '@mui/material';
import DateTimePicker from 'src/components/App/DatePicker';
import NumberInput from 'src/components/shared/Form/Number';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import { Chip, MenuItem, Select } from "@mui/material";
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg'
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { getAreaByPatientIdRequest, getPatientByIdRequest, getTagByPatientIdRequest, getTagsRequest, getAreasRequest, updatePatientByIdRequest, updateAreaByIdReuest, updateTagByIdReuest, postTagRequest, postAreaRequest, postUploadRequest } from 'src/modules/app/store/appActions';
import useAppointmentDetails from '../../UseAppointmentDetails';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import storage from 'src/utils/storageUtils';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive';




function EditProfile({ onClose }) {
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const [newTagName, setNewTagName] = useState('');
    const [newAreaName, setNewAreaName] = useState('');

    const { PatientId, user, appointmentDetails } = useAppointmentDetails();
    const patientData = useSelector((state) => state.app.patientById?.payload?.data?.patient);
    const tagData = useSelector((state) => state.app.TagByPatientId?.payload?.data);
    const tagId = tagData?.[0]?.id;
    const areaData = useSelector((state) => state.app.AreaByPatientId?.payload?.data);
    const areaId = areaData?.[0]?.id;
    const clinicData = useSelector((state) => state.app.clinics);

    const clinicId = clinicData?.clinicId;
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const [areas, setAreas] = useState([]);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");
    const fileInputRef = React.useRef();


    const handleOpen = (type) => {
        setDialogType(type);

        if (type === 'add new tag') {
            const rawTags = tagData?.[0]?.tag;
            const existingTags = Array.isArray(rawTags) ? rawTags : typeof rawTags === 'string' ? [rawTags] : [];
            setNewTagName(existingTags.join(', '));
        }

        if (type === 'add new location') {
            const existingArea = areaData?.[0]?.area || '';
            setNewAreaName(existingArea);
        }

        setOpen(true);
    };

    const handleClose = () => setOpen(false);
    const Gender = [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Other', value: 'other' },
    ];

    const validationSchema = Yup.object().shape({
        newpatient: Yup.string()
            .required('Patient name is required')
            .min(2, 'Name must be at least 2 characters'),

        // contactNo: Yup.string()
        //     .required('Contact number is required')
        //     .matches(/^[0-9]{10}$/, 'Contact number must be 10 digits'), // Example for 10 digits

        gender: Yup.string()
            .required('Gender is required')
            .oneOf(['male', 'female', 'other'], 'Invalid gender'),

        dob: Yup.date()
            .nullable()
            .max(new Date(), 'Date of Birth cannot be in the future')
            .required('Date of Birth is required'),

        tag: Yup.array()
            .of(Yup.string())
            .nullable()
            .min(1, 'At least one tag must be selected'),

        area: Yup.string().required('Area must be selected')

    });

    const modifiedTags = [
        {
            label: 'Add New Tag', value: 'add new tag', customStyle: {
                color: `${theme.palette.primary.main} !important`,
                '&:hover': {
                    backgroundColor: 'transparent !important',
                },
            }

        },
        ...tags,
    ];
    const modifiedAreas = [
        {
            label: 'Add New Location',
            value: 'add new location',
            customStyle: {
                color: `${theme.palette.primary.main} !important`,
                '&:hover': {
                    backgroundColor: 'transparent !important',
                },
            },

        },
        ...areas,
    ]
    useEffect(() => {
        const token = storage.get('TOKEN');

        if (PatientId) {
            dispatch(getPatientByIdRequest(PatientId));
            dispatch(getTagByPatientIdRequest(PatientId));
            dispatch(getAreaByPatientIdRequest(PatientId));
        }

        const fetchMeta = async () => {
            try {
                // GET TAGS
                const tagsResponse = await new Promise((resolve, reject) =>
                    dispatch(getTagsRequest(token, resolve, reject))
                );
                if (tagsResponse && tagsResponse.length) {
                    const flatTagList = tagsResponse.flatMap((item) => item.tag || []);
                    const uniqueTags = [...new Set(flatTagList)];
                    setTags(uniqueTags.map((tag) => ({
                        label: tag,
                        value: tag,
                    })));
                }

                // GET AREAS
                const areasResponse = await new Promise((resolve, reject) =>
                    dispatch(getAreasRequest(token, resolve, reject))
                );
                console.log("here is area responses", areasResponse)
                if (areasResponse && areasResponse.length) {
                    const rawAreas = areasResponse.map((item) => item.area).filter(Boolean);
                    const uniqueAreas = [...new Set(rawAreas)];

                    setAreas(
                        uniqueAreas.map((area) => ({
                            label: area,
                            value: area,
                        }))
                    );
                }


            } catch (err) {
                console.error("Error fetching meta data:", err);
            }
        };

        fetchMeta();
    }, [PatientId, dispatch]);

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const PatientDatas = {
                fullName: values.newpatient,
                // contactNo: values.contactNo,
                gender: values.gender,
                dateOfBirth: values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : null,
            };

            const AreaDatas = {
                area: Array.isArray(values.area) ? values.area[0] : values.area,
                patient: PatientId,
                clinic: clinicId,
                user,
            };

            const TagDatas = {
                tag: values.tag,
                patient: PatientId,
                user,
            };

            const areaPromise = areaId
                ? new Promise((resolve, reject) =>
                    dispatch(updateAreaByIdReuest(areaId, AreaDatas, resolve, reject))
                )
                : new Promise((resolve, reject) =>
                    dispatch(postAreaRequest(AreaDatas, resolve, reject))
                );

            const tagPromise = tagId
                ? new Promise((resolve, reject) =>
                    dispatch(updateTagByIdReuest(tagId, TagDatas, resolve, reject))
                )
                : new Promise((resolve, reject) =>
                    dispatch(postTagRequest(TagDatas, resolve, reject))
                );

            const [patientDataRes, areaRes, tagRes] = await Promise.all([
                new Promise((resolve, reject) =>
                    dispatch(updatePatientByIdRequest(PatientId, PatientDatas, resolve, reject))
                ),
                areaPromise,
                tagPromise,
            ]);


            await Promise.all([
                dispatch(getPatientByIdRequest(PatientId)),
                dispatch(getTagByPatientIdRequest(PatientId)),
                dispatch(getAreaByPatientIdRequest(PatientId)),
            ]);
            toast.success("Profile updated successfully!");
            resetForm();
            onClose();
        } catch (error) {
            toast.error("Failed to update profile.");
            console.error('Error updating patient profile:', error);
        }
    };


    const handleAreaSubmit = async () => {
        const data = {
            area: newAreaName,
            user,
            patient: PatientId,
            clinic: clinicId,
        };

        try {

            const latestArea = await new Promise((resolve, reject) =>
                dispatch(getAreaByPatientIdRequest(PatientId, resolve, reject))
            );
            const existingAreaId = latestArea?.[0]?.id;

            if (existingAreaId) {
                await new Promise((resolve, reject) =>
                    dispatch(updateAreaByIdReuest(existingAreaId, data, resolve, reject))
                );
            } else {

                await new Promise((resolve, reject) =>
                    dispatch(postAreaRequest(data, resolve, reject))
                );
            }
            await dispatch(getAreaByPatientIdRequest(PatientId))
            setAreas(prev => [...prev, { label: newAreaName, value: newAreaName }]);
            setNewAreaName('');
            toast.success("Location saved successfully!");

            handleClose();
        } catch (error) {
            console.error("Failed to save area:", error);
            toast.error("Failed to save location.");
        }
    };

    const handleTagSubmit = async () => {
        const data = {
            tag: newTagName,
            user,
            patient: PatientId,
        };

        try {
            const latestTag = await new Promise((resolve, reject) =>
                dispatch(getTagByPatientIdRequest(PatientId, resolve, reject))
            );
            const existingTagId = latestTag?.[0]?.id;

            if (existingTagId) {
                await new Promise((resolve, reject) =>
                    dispatch(updateTagByIdReuest(existingTagId, data, resolve, reject))
                );
            } else {
                await new Promise((resolve, reject) =>
                    dispatch(postTagRequest(data, resolve, reject))
                );
            }

            const token = storage.get('TOKEN');
            const allTags = await new Promise((resolve, reject) =>
                dispatch(getTagsRequest(token, resolve, reject))
            );
            const flatTags = allTags.flatMap((item) => item.tag || []);
            const uniqueTags = [...new Set(flatTags)];
            setTags(uniqueTags.map((tag) => ({
                label: tag,
                value: tag,
            })));
            await dispatch(getTagByPatientIdRequest(PatientId))


            setNewTagName('');
            toast.success("Tag saved successfully!");
            handleClose();
        } catch (error) {
            console.error("Failed to save tag:", error);
            toast.error("Failed to save Tags.");

        }
    };
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    newpatient: patientData?.fullName || '',
                    // contactNo: patientData?.contactNo || '',
                    gender: patientData?.gender || '',
                    dob: patientData?.dateOfBirth ? dayjs(patientData.dateOfBirth) : (patientData?.age ? dayjs().subtract(patientData.age, 'year') : null),
                    tag: Array.isArray(tagData?.[0]?.tag) ? tagData[0].tag : [],
                    area: areaData?.[0]?.area
                        ? [areaData[0].area]
                        : [],
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form>
                        <HeaderPart>
                            Edit Profile Details
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <EditContainer>
                            <AddContainer sx={{ width: isMobile || isTablet ? 'auto' : '470px', alignItems: 'center' }}>
                                <ProfileContainer>
                                    <ProfileAvatar>
                                        {patientData?.fullName?.charAt(0).toUpperCase() || 'N/A'}
                                    </ProfileAvatar>
                                </ProfileContainer>
                                <EditLine sx={{ width: '1', height: '0' }} />
                                <TagsContainer >
                                    <Texts>Tags</Texts>
                                    <InputSelect
                                        name="tag"
                                        multiple={true}
                                        showNone={false}
                                        value={values.tag}
                                        options={modifiedTags}
                                        onChange={(value) => {
                                            if (
                                                (Array.isArray(value) && value.includes("add new tag")) ||
                                                value === "add new tag"
                                            ) {
                                                handleOpen("add new tag");
                                                return;
                                            }
                                            setFieldValue('tag', value);
                                        }}
                                        onBlur={handleBlur}
                                        error={touched.tag && Boolean(errors.tag)}
                                        helperText={touched.tag && errors.tag}
                                        variant="outlined"
                                        placeholder="Select Multiple"
                                        fullWidth
                                        renderValue={(selected) => (
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                                {selected.map((tag) => (
                                                    <Chip
                                                        key={tag}
                                                        label={tag}
                                                        onDelete={() => handleChange("tag", selected.filter((t) => t !== tag))}
                                                        deleteIcon={
                                                            <Close
                                                                sx={{
                                                                    color: theme.palette.action.red,
                                                                }}
                                                            />
                                                        }
                                                        sx={{
                                                            backgroundColor: theme.palette.primary.light3,
                                                            color: "#000",
                                                            borderRadius: "16px",
                                                            padding: "4px 4px 4px 8px",
                                                            ...theme.typography.body1,

                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        )}

                                        sx={{

                                            boxShadow: theme.shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />

                                </TagsContainer>


                            </AddContainer>
                            <EditLine />
                            <AddContainer sx={{ width: isMobile || isTablet ? 'auto' : '460px' }}>
                                <TagsContainer>
                                    {/* <InnerComponent> */}
                                    <Texts>Patient Name</Texts>
                                    <InputComponent
                                        name="newpatient"
                                        value={values.newpatient}
                                        onChange={handleChange}
                                        variant="outlined"
                                        placeholder="Enter Name"
                                        fullWidth
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],

                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                // border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                // alignItems: 'flex-start',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,

                                            },
                                        }}
                                    />
                                    {/* </InnerComponent> */}
                                    {/* <InnerComponent>
                                        <Texts>Phone Number</Texts>
                                        <InputComponent
                                            name="contactNo"
                                            value={values.contactNo}
                                            onChange={handleChange}
                                            variant="outlined"
                                            placeholder="Enter Number"
                                            fullWidth
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],

                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 0px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                            }}
                                        />


                                    </InnerComponent> */}
                                </TagsContainer>
                                <Component2>
                                    <InnerComponent>
                                        <Texts>Gender</Texts>
                                        <InputSelect
                                            name="gender"
                                            showNone={false}
                                            value={values.gender}
                                            options={Gender}
                                            onChange={(value) => setFieldValue('gender', value)}
                                            variant="outlined"
                                            placeholder="Select"
                                            sx={{
                                                // width: '200px',
                                                boxShadow: theme.shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    height: '52px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                                    borderRadius: '12px',
                                                },
                                            }}
                                        />

                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Date of Birth</Texts>
                                        <DateTimePicker
                                            // label="Date of Birth"
                                            name="dob"
                                            value={values.dob}
                                            onChange={(value) => setFieldValue('dob', value)}
                                            type="date"
                                            maxDate={new Date()}
                                            sx={{
                                                height: "52px",
                                                borderRadius: '12px',
                                                // padding: '10px 16px',
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>
                                <TagsContainer>

                                    <Texts>Location</Texts>
                                    <InputSelect
                                        name="area"
                                        // multiple={true}
                                        showNone={false}
                                        value={values.area}
                                        options={modifiedAreas}
                                        onChange={(value) => {
                                            if (
                                                (Array.isArray(value) && value.includes("add new location")) ||
                                                value === "add new location"
                                            ) {
                                                handleOpen("add new location");
                                                return;
                                            }

                                            setFieldValue('area', value);
                                        }}
                                        onBlur={handleBlur}
                                        error={touched.area && Boolean(errors.area)}
                                        helperText={touched.area && errors.area}

                                        variant="outlined"
                                        placeholder="Select"
                                        fullWidth

                                        sx={{
                                            // width: '200px',
                                            boxShadow: theme.shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                height: '52px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />

                                </TagsContainer>
                            </AddContainer>

                        </EditContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={onClose}
                            >
                                Cancel
                            </CancelButton>

                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                            >Save</SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik >

            <DialogBox open={open}>
                {dialogType === 'add new tag' ?
                    <>
                        <HeaderPart>
                            Add New Tag
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={handleClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4>
                                <Texts>New Tag Name</Texts>
                                <InputComponent
                                    value={newTagName}
                                    onChange={(e) => setNewTagName(e.target.value)}
                                    variant="outlined"
                                    placeholder="Enter Tag"
                                    fullWidth
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            // padding: '10px 18px',
                                            borderRadius: '12px',
                                            height: '52px',
                                            // border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />

                            </Component4>
                        </AddContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={handleClose}
                            >
                                Cancel
                            </CancelButton>

                            <SaveButton
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                                onClick={handleTagSubmit}
                            >Save</SaveButton>
                        </FooterPart>
                    </>
                    :
                    <>
                        <HeaderPart>
                            Add New Area
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={handleClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4>
                                <Texts>New Location Name</Texts>
                                <InputComponent
                                    value={newAreaName}
                                    onChange={(e) => setNewAreaName(e.target.value)}
                                    variant="outlined"
                                    placeholder="Enter Location"
                                    fullWidth
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            // padding: '10px 18px',
                                            borderRadius: '12px',
                                            height: '52px',
                                            // border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />

                            </Component4>
                        </AddContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={handleClose}
                            >
                                Cancel
                            </CancelButton>

                            <SaveButton
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                                onClick={handleAreaSubmit}
                            >Save</SaveButton>
                        </FooterPart>
                    </>
                }
            </DialogBox>
        </>
    )
}

export default EditProfile
